var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 4 22"}},[_c('circle',{attrs:{"cx":"1.9","cy":"1.9","r":"1.9","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"1.9","cy":"10.7","r":"1.9","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"1.9","cy":"19.5","r":"1.9","fill":"currentColor"}})])
}
var staticRenderFns = []

export default { render: render }